<div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-black  backdrop-blur-lg opacity-75 flex flex-col items-center justify-center">
	<div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
	<!-- <img src="../../../assets/images/Splash_screen_Wardrobes_1_V2.gif" height="20px" width="10px"> -->
	<h2 class="text-center text-white text-xl font-semibold">{{title}}</h2>
	<p class="w-1/3 text-center text-white">{{message}}</p>
</div>
 